import { Link } from 'react-router-dom';
import { siteBrand, navLinks, contactEmail } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50">{siteBrand}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              一本专注于《泡在我家的辣妹》漫画的剧情资讯站，帮你理清故事主线、角色设定与分集剧情，让每一位读者在开看之前都能快速进入状态。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href={`mailto:${contactEmail}`}
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
              >
                <i className="ri-mail-line"></i>
                联系我们
              </a>
              <span className="inline-flex items-center gap-2 rounded-md border border-background-200/30 px-4 py-2 text-sm text-background-200">
                <i className="ri-heart-3-line text-primary-400"></i>
                支持正版 · 快乐追漫
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {navLinks.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-background-300 transition-colors hover:text-background-50">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50">关于作品</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li>题材：校园恋爱喜剧</li>
              <li>核心看点：同居日常 · 反差萌</li>
              <li>联系邮箱：{contactEmail}</li>
              <li>本站仅做剧情整理与介绍</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200/20 pt-6 sm:flex-row">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} {siteBrand} 剧情资讯站 · 本站仅用于剧情整理与交流，请支持作品正版
          </p>
          <p className="flex items-center gap-1.5 text-xs text-background-300">
            <i className="ri-heart-fill text-primary-400"></i>
            用热爱整理每一话剧情
          </p>
        </div>
      </div>
    </footer>
  );
}